module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-field",
    class: [{
      'cb-field--active': (_vm.internalValue || _vm.focussed || _vm.isDate)
    }, _vm.customClass, {
      'cb-field--error': (!!_vm.errorMessage && !_vm.focussed)
    }, {
      'cb-field--sibling': _vm.siblingError
    }, {
      'cb-field--focus': _vm.focussed && !_vm.readonly
    }, {
      'cb-field--select-alt': this.config.meta.help_text
    }]
  }, [_c('input', {
    ref: "input",
    staticClass: "cb-field__control",
    class: {
      'cb-field__readonly': _vm.readonly
    },
    attrs: {
      "type": "date",
      "readonly": _vm.readonly,
      "placeholder": _vm.isDate && _vm._timestampPlaceholder,
      "name": _vm.name,
      "aria-disabled": _vm.readonly,
      "disabled": _vm.readonly,
      "aria-required": _vm.required,
      "id": _vm.name
    },
    domProps: {
      "value": _vm.displayValue
    },
    on: {
      "click": function($event) {
        _vm.focus($event)
      },
      "focus": function($event) {
        _vm.focus($event)
      },
      "blur": function($event) {
        _vm.blur($event)
      },
      "keyup": function($event) {
        _vm.keyup($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "cb-field__label",
    class: {
      'cb-field__label--s': _vm.isShort
    },
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(" " + _vm._s(_vm.displayLabel))]), _vm._v(" "), _vm._t("default"), _vm._v(" "), (this.config.meta.help_text) ? _c('div', {
    staticClass: "cb-field__help"
  }, [
    [_c('div', {
      ref: "helpText",
      staticClass: "cb-field__trigger",
      class: {
        'active-opacity': _vm.helpTextShown
      },
      on: {
        "click": function($event) {
          _vm.showHelpText($event)
        }
      }
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "help-text"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.helpTextShown),
        expression: "helpTextShown"
      }],
      staticClass: "cb-field__menu"
    }, [_vm._v("\n          " + _vm._s(this.config.meta.help_text) + "\n        ")])])]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.errorMessageWrapper && !_vm.focussed) ? _c('div', {
    staticClass: "cb-field__error"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessageWrapper) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49fcedda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/form/Timestamp.vue
// module id = 205
// module chunks = 1 2 3 4 5 25 29 30 31 32 66 67